export const committeeInitialState = {
  currentCommittee: null,
  currentCommitteeIsLoading: true,
  committees: null,
  committeesIsLoading: true,
};